/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { cloneDeep, uniqueId } from 'lodash';
// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseTextarea from 'shared/ui/components/form-components/BaseTextarea.vue';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';
import DropdownMenu from 'shared/ui/components/DropdownMenu.vue';
import MetaControl from 'shared/ui/components/form-components/MetaControl.vue';
import MetadataCategorySelector from './MetadataCategorySelector.vue';
import MetadataEditChoiceList from './MetadataEditChoiceList.vue';
import MetadataExternalTypeSelector from './MetadataExternalTypeSelector.vue';
import MetadataKindSelector from './MetadataKindSelector.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

// Editors
import DatetimeConfigModal from 'shared/ui/components/form-components/registrations/DatetimeConfigModal.vue';

const __vue_script__ = {
    name: 'MetadataFieldForm',

    components: {
        BaseInput,
        BaseTextarea,
        Checkbox,
        DropdownMenu,
        MetaControl,
        MetadataCategorySelector,
        MetadataEditChoiceList,
        MetadataExternalTypeSelector,
        MetadataKindSelector,
        Toggler
    },

    props: {
        categoryIndex: {
            type: Number,
            required: true,
        },

        fieldIndex: {
            type: Number,
            required: true,
        },

        fpType: {
            type: String,
            required: true
        },

        publicAccess: {
            type: Boolean,
            default: true
        },

        kindsPurpose: {
            type: String,
            default: undefined
        },

        showHiddenFields: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            allowMultipleDocs: true,
            definition: {},
            ensureReferentialIntegrity: false,
            fieldName: null,
            fieldNameValidators: null,
            hasExternalType: false,
            hidePlaceholder: false,
            isCarbonCopy: false,
            isPrivate: false,
            isPubliclyWriteProtected: false,
            isReadOnly: false,
            isRequired: false,
            appHidden: false,
            kind: 'default',
            metaControl: {},
            originalControl: null,
            ready: false,
            showDefault: false,
            showExtendedControls: false,
            toDelete: false,
        };
    },

    computed: {
        eid() {
            return this.$store.state.metadataEditor.eid;
        },

        event() {
            return this.$store.state.metadataEditor.eventDoc || {};
        },

        focused() { // needed for the scroll into view of newly created fields or fields that change category
            return this.$store.state.metadataEditor.focused;
        },

        rev() {
            return this.$store.getters.fieldRev({
                categoryIndex: this.categoryIndex,
                fieldIndex: this.fieldIndex,
            });
        },

        settings() {
            return this.$store.state.metadataEditor.settings || {};
        },

        isOptionsEditorAvailable() {
            return this.kind === 'formatted-datetime';
        },

        allowsAppHiddenFields() {
            return this.fpType === 'prospect';
        },

        hasPublicWriteProtection() {
            return (this.fpType === 'person' || this.fpType === 'meeting')
                && !this.definition.never_write_protected;
        },

        showAppModToggler() {
            return this.publicAccess && this.hasPublicWriteProtection && this.kind !== 'hidden';
        },

        showPrivateToggler() {
            return this.publicAccess && !this.isReadOnly && this.fpType === 'person' && this.kind !== 'hidden';
        },

        showDropDown() {
            return this.fieldIndex !== 0 || !this.isReadOnly;
        },

        showCarbonCopyToggler() {
            return this.showExtendedControls && this.definition.kind === 'email' && this.fpType === 'person' && !this.isReadOnly;
        },

        showDescriptionInput() {
            return this.fpType === 'person' && this.$services.metadata.KINDS_SUPPORTING_DESCRIPTION.includes(this.definition.kind);
        },
    },

    watch: {
        rev: {
            immediate: true,
            handler() {
                this.onDefinitionChange();
            }
        },

        fieldName(value) {
            if (this.definition?.name) {
                this.onChange(value, ['definition', 'name']);
            }
            this.onChange(value, ['field']);
            if (!this.originalControl.field) {
                this.originalControl.field = value;
            }
        },

        isCarbonCopy(value) {
            if (!value) return;

            if (!this.definition.description) {
                this.definition.description = this.$t('metadata_editor.carbon_copy_description');
                this.setDefinition('description', this.definition.description);
            }

            if (!this.definition.tooltip) {
                this.definition.tooltip = this.$t('metadata_editor.carbon_copy_tooltip');
                this.setDefinition('tooltip', this.definition.tooltip);
            }
        }
    },

    created() {
        this.fieldName = this.$store.getters.fieldName({
            categoryIndex: this.categoryIndex,
            fieldIndex: this.fieldIndex,
        });

        if (this.$store.state.metadataEditor.focused === this.fieldName) {
            this.scrollIntoView();
        }

        this.fieldNameValidators = {
            metadata_field_name: true,
            required: true,
            unique_field_name: {
                names: this.$store.getters.allFieldNames
            }
        };

        const allowedKinds = this.kindsPurpose === 'registration' ?
            this.$services.metadata.REGISTRATION_ALLOWED_KINDS :
            this.$services.metadata.EDITABLE_KINDS;

        const isNotEditable = this.definition?._editable === false || !allowedKinds.includes(this.definition?.kind);
        const hasCustomController = Boolean(this.definition?.kind === 'custom' && this.definition?.kind_options && this.definition?.kind_options.controller);
        const isPrivateField = this.fieldName?.startsWith('fp_');
        this.isReadOnly = isNotEditable || hasCustomController || isPrivateField;
        this.ready = true;
    },

    methods: {
        onDefinitionChange() {
            this.definition = this.$store.getters.fieldDefinition({
                categoryIndex: this.categoryIndex,
                fieldIndex: this.fieldIndex,
            });

            this.ensureReferentialIntegrity = Boolean(this.definition?.kind_options?.ensure_referential_integrity);
            this.hasExternalType = Boolean(this.definition.kind === 'external');
            this.hidePlaceholder = [
                'auto',
                'boolean',
                'choice',
                'choice-list',
                'custom',
                'display-only',
                'formatted-datetime',
                'list',
                'nested-object',
                'timestamp',
                'video-call',
            ].includes(this.definition.kind);

            this.isRequired = Boolean(this.definition?.validations?.required);
            this.isPubliclyWriteProtected = Boolean(this.definition?.pub_write_protected);
            this.isCarbonCopy = Boolean(this.definition?.kind_options?.carbon_copy);
            this.isPrivate = Boolean(this.definition?.crypt);
            this.allowMultipleDocs = !this.definition?.kind_options?.single_doc;
            this.appHidden = this.definition.hidden && this.definition.app_hidden;
            this.kind = this.definition.kind;

            this.toDelete = Boolean(this.definition._to_delete);

            this.showDefault = Boolean(
                // changes to custom type default value does not work at the moment
                this.kind !== 'custom' &&
                // default value for external type can not be chosen if kind_options.type is not defined
                !(this.kind === 'external' && !this.definition?.kind_options?.type) &&
                // default value for select fields breaks if there are no options
                !(['choice', 'choice-list'].includes(this.kind) && !this.definition?.kind_options?.values) ||
                this.kind === 'hidden' && this.showHiddenFields === true
            );

            this.metaControl = {
                ...this.definition,
                field: this.fieldName,
                name: uniqueId('default_'),
            };

            if (!this.originalControl) {
                this.originalControl = cloneDeep(this.metaControl);
            }
        },

        /**
         * @param {string} key
         * @param {unknown} [defaultValue]
         */
        getKindOptionsKey(key, defaultValue) {
            const kindOptions = this.definition.kind_options || {};
            return kindOptions[key] || defaultValue;
        },

        /**
         * @param {unknown} value
         * @param {string[]} path
         */
        onChange(value, path) {
            this.$store.commit('updateMetadataField', {
                categoryIndex: this.categoryIndex,
                fieldIndex: this.fieldIndex,
                path,
                value,
            });
        },

        /** @type {(key: string, value: unknown) => void} */
        setDefinition(key, value) {
            this.onChange(value, ['definition', key]);
        },

        /** @type {(key: string, value: unknown) => void} */
        setKindOptions(key, value) {
            this.onChange(value, ['definition', 'kind_options', key]);
        },

        /** @type {(value: boolean, field: string) => void} */
        onBooleanChange(value, field) {
            const onIsRequiredChange = value => {
                if (value) {
                    this.setDefinition('validations', { required: true });
                } else {
                    const validations = this.definition.validations || {};
                    const hasOtherValidations = Object.keys(validations).filter(d => d !== 'required').length;
                    if (hasOtherValidations) {
                        delete validations.required;
                        this.setDefinition('validations', validations);
                    } else {
                        this.setDefinition('validations', null);
                    }
                }
            };

            switch (field) {
                case 'isCarbonCopy': return this.setKindOptions('carbon_copy', value || undefined);
                case 'isPrivate': return this.setDefinition('crypt', value || undefined);
                case 'ensureReferentialIntegrity': return this.setKindOptions('ensure_referential_integrity', value || undefined);
                case 'allowMultipleDocs': return this.setKindOptions('single_doc', value ? undefined : true);
                case 'isRequired': return onIsRequiredChange(value);
                case 'pub_write_protected': return this.setDefinition('pub_write_protected', value || undefined);
                case 'app_hidden': {
                    this.setDefinition('hidden', value || undefined);
                    this.setDefinition('app_hidden', value || undefined);

                    return;
                }
                default: return;
            }
        },

        /** @type {(externalType: string) => void} */
        onExternalTypeChange(externalType) {
            if (externalType !== this.definition.kind_options?.type) {
                this.setKindOptions('type', externalType);
                this.setDefinition('default', undefined);
            }
        },

        onKindChange(value) {
            this.kind = value;
            this.onChange(value, ['definition', 'kind']);
            this.setDefinition('default', undefined);
        },

        deleteField() {
            this.closeDropDown();

            // Restore required stuff to not interfere with validations
            this.onChange(this.originalControl.label, ['definition', 'label']);
            this.fieldName = this.originalControl.field;

            const toDelete = !this.toDelete;
            this.setDefinition('_to_delete', toDelete || undefined);
            this.toDelete = toDelete;
        },

        scrollIntoView() {
            this.$nextTick(() => this.$refs['form']?.scrollIntoView({ behavior: 'smooth' }));
        },

        /** @type {(name: string) => string} */
        prefixName(name) {
            return `${this.fieldName}_${name}`;
        },

        moveToTop() {
            this.closeDropDown();
            this.$store.commit(
                'setFieldOnTopOfCategory',
                { categoryIndex: this.categoryIndex, fieldIndex: this.fieldIndex },
            );
        },

        closeDropDown() {
            const dropDown = this.$refs['dropDownMenu'];
            if (dropDown?.hide) {
                dropDown.hide();
            }
        },

        editOptions() {
            if (this.kind === 'formatted-datetime') {
                this.openDatetimeConfigModal();
            }
        },

        /**
         * Opens the editing modal with the specified modal component and props.
         *
         * @param {string} modal - The name of the modal component to open.
         * @param {object} props - The props to pass to the modal component.
         */
        openEditingModal(modal, props) {
            this.$modal.show(modal, props, {
                classes: 'small',
                height: 'auto',
                reset: true,
                clickToClose: false
            });
        },

        /**
         * Opens the datetime configuration modal for a specific field.
         */
        openDatetimeConfigModal() {
            this.openEditingModal(DatetimeConfigModal, {
                event: this.event,
                value: this.definition,
                name: this.metaControl.field,
                saveCallback: edited => {
                    this.onChange(edited, ['definition', 'kind_options']);
                }
            });
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{ref:"form",staticClass:"metadata-field-form",class:{ 'to-delete': _vm.toDelete, 'is-focused': _vm.focused === (_vm.fieldName + "_field}") }},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"drag-handle",attrs:{"aria-label":_vm.$t('metadata_editor.drag_field'),"tabindex":"0"}},[_c('i',{staticClass:"icon-reorder"})]),_c('div',{staticClass:"controls"},[_c('div',{staticClass:"metadata-cell field-name"},[(_vm.isReadOnly)?_c('p',{staticClass:"read-only-field-name"},[_c('span',[_vm._v(_vm._s(_vm.fieldName))]),_c('i',{staticClass:"ic-lock"})]):_c('validation-provider',{ref:"fieldName",attrs:{"rules":_vm.fieldNameValidators,"slim":true,"name":"name"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{key:(_vm.categoryIndex + "-" + _vm.fieldIndex + "-field-name"),attrs:{"name":_vm.prefixName('field'),"disabled":_vm.isReadOnly,"errors":errors,"focused":_vm.focused === (_vm.fieldName + "_field")},model:{value:(_vm.fieldName),callback:function ($$v) {_vm.fieldName=$$v},expression:"fieldName"}})]}}],null,false,3602004828)}),_c('metadata-category-selector',{attrs:{"category-index":_vm.categoryIndex,"field-index":_vm.fieldIndex,"value":_vm.definition.category}})],1),_c('div',{staticClass:"metadata-cell field-kind"},[_c('metadata-kind-selector',{attrs:{"value":_vm.definition.kind,"disabled":_vm.isReadOnly,"purpose":_vm.kindsPurpose},on:{"input":_vm.onKindChange}}),(!_vm.isReadOnly && !_vm.appHidden)?_c('toggler',{attrs:{"label":_vm.$t('metadata_editor.is_required'),"inline-label":true,"name":_vm.prefixName(_vm.$t('metadata_editor.is_required')),"value":_vm.isRequired},on:{"input":function($event){return _vm.onBooleanChange($event, 'isRequired')}}}):_vm._e(),(!_vm.isReadOnly && _vm.allowsAppHiddenFields && !_vm.isRequired)?_c('toggler',{attrs:{"label":_vm.$t('metadata_editor.app_hidden_fields'),"inline-label":true,"name":_vm.prefixName(_vm.$t('metadata_editor.app_hidden_description')),"value":_vm.appHidden},on:{"input":function($event){return _vm.onBooleanChange($event, 'app_hidden')}}}):_vm._e(),(_vm.showExtendedControls && !_vm.isReadOnly && ['choice', 'choice-list'].includes(_vm.kind))?_c('metadata-edit-choice-list',{attrs:{"category-index":_vm.categoryIndex,"field-index":_vm.fieldIndex,"values":_vm.getKindOptionsKey('values', {}),"values-order":_vm.getKindOptionsKey('values_order', {})}}):_vm._e(),(_vm.showExtendedControls && _vm.hasExternalType)?_c('metadata-external-type-selector',{attrs:{"disabled":_vm.isReadOnly,"value":_vm.getKindOptionsKey('type')},on:{"change":_vm.onExternalTypeChange}}):_vm._e(),(_vm.showExtendedControls && _vm.hasExternalType)?_c('toggler',{attrs:{"disabled":_vm.isReadOnly,"label":_vm.$t('metadata_editor.ensure_referential_integrity'),"inline-label":true,"name":_vm.prefixName(_vm.$t('metadata_editor.ensure_referential_integrity')),"value":_vm.ensureReferentialIntegrity},on:{"input":function($event){return _vm.onBooleanChange($event, 'ensureReferentialIntegrity')}}}):_vm._e(),(_vm.showExtendedControls && _vm.hasExternalType)?_c('toggler',{attrs:{"disabled":_vm.isReadOnly,"label":_vm.$t('metadata_editor.allow_multiple_docs'),"inline-label":true,"name":_vm.prefixName(_vm.$t('metadata_editor.allow_multiple_docs')),"value":_vm.allowMultipleDocs},on:{"input":function($event){return _vm.onBooleanChange($event, 'allowMultipleDocs')}}}):_vm._e(),(_vm.showExtendedControls && _vm.showAppModToggler)?_c('toggler',{attrs:{"label":_vm.$t('metadata_editor.write_protected'),"inline-label":true,"name":_vm.prefixName(_vm.$t('metadata_editor.write_protected')),"value":_vm.isPubliclyWriteProtected},on:{"input":function($event){return _vm.onBooleanChange($event, 'pub_write_protected')}}}):_vm._e(),(_vm.showExtendedControls && _vm.showPrivateToggler)?_c('toggler',{attrs:{"label":_vm.$t('metadata_editor.private'),"inline-label":true,"name":_vm.prefixName(_vm.$t('metadata_editor.private')),"value":_vm.isPrivate,"tip":_vm.$t('metadata_editor.private_tip')},on:{"input":function($event){return _vm.onBooleanChange($event, 'isPrivate')}}}):_vm._e(),(_vm.showCarbonCopyToggler)?_c('toggler',{attrs:{"label":_vm.$t('metadata_editor.carbon_copy'),"inline-label":true,"name":_vm.prefixName(_vm.$t('metadata_editor.carbon_copy')),"value":_vm.isCarbonCopy,"tip":_vm.$t('metadata_editor.carbon_copy_tip')},on:{"input":function($event){return _vm.onBooleanChange($event, 'isCarbonCopy')}},scopedSlots:_vm._u([{key:"hint",fn:function(ref){return [_c('span',[_vm._v(_vm._s(_vm.$t('general.need_help')))]),_vm._v(" "),_c('a',{attrs:{"href":_vm.$utils.links.getLinkUrl('metadata_cc_field'),"title":_vm.$t('general.learn_more'),"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.$t('general.learn_more')))])]}}],null,false,1726230371)}):_vm._e()],1),_c('div',{staticClass:"metadata-cell labelling"},[_c('validation-provider',{attrs:{"rules":_vm.isReadOnly ? '' : 'required',"slim":true,"name":"label"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"name":"label","value":_vm.definition.label,"errors":errors,"placeholder":_vm.$t('metadata_editor.label')},on:{"input":function($event){return _vm.onChange($event, ['definition', 'label'])}}})]}}],null,false,289204169)}),(_vm.showExtendedControls && _vm.showDescriptionInput)?_c('base-textarea',{attrs:{"name":"description","rows":_vm.definition.description ? null : 1,"label":_vm.$t('metadata_editor.description'),"hint":_vm.$t('metadata_editor.description_hint'),"hint-after-label":true,"value":_vm.definition.description},on:{"input":function($event){return _vm.onChange($event, ['definition', 'description'])}}}):_vm._e(),(_vm.showExtendedControls)?_c('base-textarea',{attrs:{"name":"tooltip","rows":_vm.definition.tooltip ? null : 1,"label":_vm.$t('metadata_editor.tooltip'),"hint":_vm.$t('metadata_editor.tooltip_hint'),"hint-after-label":true,"value":_vm.definition.tooltip},on:{"input":function($event){return _vm.onChange($event, ['definition', 'tooltip'])}}}):_vm._e(),(_vm.showExtendedControls && !_vm.hidePlaceholder)?_c('base-textarea',{attrs:{"name":"placeholder","rows":_vm.definition.example ? null : 1,"label":_vm.$t('metadata_editor.placeholder'),"hint":_vm.$t('metadata_editor.placeholder_hint'),"hint-after-label":true,"value":_vm.definition.example},on:{"input":function($event){return _vm.onChange($event, ['definition', 'example'])}}}):_vm._e()],1),_c('div',{staticClass:"metadata-cell default-value"},[(_vm.showDefault)?_c('meta-control',{attrs:{"settings":_vm.settings,"control":_vm.metaControl,"event":_vm.event,"value":_vm.definition.default,"tip":_vm.definition.tooltip,"show-hidden":_vm.showHiddenFields,"name":_vm.prefixName(_vm.$t('metadata_editor.default'))},on:{"input":function($event){return _vm.onChange($event, ['definition', 'default'])}}}):_vm._e(),(_vm.isOptionsEditorAvailable)?_c('button',{staticClass:"btn btn-icon",attrs:{"type":"button"},on:{"click":function($event){return _vm.editOptions()}}},[_c('i',{staticClass:"ic-edit"}),_vm._v(_vm._s(_vm.$t('metadata_editor.edit_options')))]):_vm._e()],1)]),_c('div',{staticClass:"field-actions"},[(_vm.showDropDown)?_c('dropdown-menu',{ref:"dropDownMenu",staticClass:"embedded",attrs:{"anchor-pos":"ne"}},[_c('ul',[(_vm.fieldIndex !== 0)?_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.moveToTop.apply(null, arguments)}}},[_c('i',{staticClass:"ic-arrow-up"}),_vm._v(_vm._s(_vm.$t('metadata_editor.move_to_top')))])]):_vm._e(),(!_vm.isReadOnly)?_c('li',[_c('a',{class:{ 'danger': !_vm.toDelete, 'success': _vm.toDelete },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.deleteField.apply(null, arguments)}}},[_c('i',{class:{'ic-trash-2': !_vm.toDelete, 'ic-restore': _vm.toDelete }}),_vm._v(_vm._s(_vm.toDelete ? _vm.$t('metadata_editor.restore') : _vm.$t('general.delete')))])]):_vm._e()])]):_vm._e()],1)]),_c('div',{staticClass:"controls-toggler has-action",attrs:{"tabindex":"0"},on:{"click":function($event){_vm.showExtendedControls = !_vm.showExtendedControls},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.showExtendedControls = !_vm.showExtendedControls}}},[(!_vm.showExtendedControls)?_c('span',{staticClass:"more"},[_vm._v(_vm._s(_vm.$t('metadata_editor.field_controls.more'))),_c('i',{staticClass:"ic-chevron-down"})]):_c('span',{staticClass:"less"},[_vm._v(_vm._s(_vm.$t('metadata_editor.field_controls.less'))),_c('i',{staticClass:"ic-chevron-up"})])])]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MetadataFieldForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__